import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    LinearProgress,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography,
    withStyles,
} from '@material-ui/core';
import { useState, useEffect } from 'react';
import { adminServerInstance } from '../../axios/instances';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    secondGrid: {
        marginTop: "14px"
    },
    selectWidth: {
        width: 200
    }
}));

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 15,
        borderRadius: 5,
    },
    colorPrimary: {
        backgroundColor: '#EEEEEE',
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

export default function ResendOrderFileUploader(props) {
    const classes = useStyles();
    const {t} = useTranslation('resendOrders');

    const [warehouse, setWarehouse] = useState('');
    const [reqDate, setReqDate] = useState('');
    const [progress, setProgress] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);

    const uploadFile = (file, onUploadProgress) => {
        let formData = new FormData();

        formData.append('file', file);
        formData.append('local_import', 1);
        formData.append('req_date', reqDate);
        formData.append('warehouse', warehouse);

        return adminServerInstance.post(
            '/business/createresendorder',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress,
            }
        );
    };

    const uploading = () => {
        uploadFile(selectedFile, (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
        }).catch(() => {
            setProgress(0);
        });

        setSelectedFile(undefined);
    };

    return (
        <Box>
            <Grid container spacing={3}>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink id="upload-warehouse-label">
                                {t('warehouse')}
                            </InputLabel>
                            <Select
                                className={classes.selectStyle}
                                labelId="upload-warehouse-label"
                                id="upload-warehouse-select"
                                defaultValue={`1`}
                                displayEmpty
                                onChange={(e) => setWarehouse(e.target.value)}
                                className={classes.selectWidth}
                            >
                                {
                                    (props.branches).map((branch, index) => {
                                        return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>   
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item className={classes.secondGrid}>
                        <FormControl className={classes.formControl}>
                            <InputLabel 
                                shrink 
                                id="upload-ordertime-label"
                                className={classes.selectWidth}
                            >
                                {t('input_order_date')}
                            </InputLabel>
                            <TextField
                                labelId="upload-ordertime-label"
                                id="upload-ordertime-input"
                                helperText="YYYYMMDD"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="filled"
                                value={reqDate}
                                onChange={(e) => setReqDate(e.target.value)}
                                className={classes.selectWidth}
                            />
                        </FormControl>
                    </Grid>                   
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <input
                        color="primary"
                        type="file"
                        id="button-file"
                        onChange={(e) => setSelectedFile(e.target.files[0])}
                        style={{display: 'none'}}
                    />
                    <Grid item>
                        <label htmlFor="button-file">
                            <Button
                                variant="contained"
                                component="span"
                                className={classes.selectWidth}
                                color="primary"
                            >
                                {t('select_file')}
                            </Button>
                        </label>
                    </Grid>
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">                
                    <Grid item>
                        <div className="file-name">
                            {selectedFile ? selectedFile.name : null}
                        </div>
                        <Button
                            color="primary"
                            variant="contained"
                            component="span"
                            disabled={!selectedFile}
                            onClick={uploading}
                            className={classes.selectWidth}
                        >
                            {t('upload')}
                        </Button>
                    </Grid>                   
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        {selectedFile && (
                            <Box
                                className="mb25"
                                display="flex"
                                alignItems="center">
                                <Box width="100%" mr={1}>
                                    <BorderLinearProgress
                                        variant="determinate"
                                        value={progress}
                                    />
                                </Box>
                                <Box minWidth={35}>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary">{`${progress}%`}</Typography>
                                </Box>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
